import { getSlideIndexInHash } from '../slideshow';

export function* countAdsOnPageGenerator() {
  let total = 5;
  let shouldRestart = false;

  while (true) {
    shouldRestart = yield total;
    total = total + 1;
    if (shouldRestart) {
      total = 5;
      shouldRestart = false;
    }
  }
}

export function getSlideAdCountValue(position, location) {
  const numberofAdsPerSlide = 2;
  const pageIndex = getSlideIndexInHash(location);
  const adOffset = position === 'top' ? 5 : 6;

  return (pageIndex * numberofAdsPerSlide) + adOffset;
}
